module.exports = __webpack_public_path__ + "img/Ellipse 4.68f75304.svg";